var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1978 16.8932L50.0584 18.0327C49.1274 18.9637 47.8895 19.4764 46.5727 19.4764C45.2559 19.4764 44.0182 18.9637 43.0871 18.0327C42.156 17.1017 41.6433 15.8637 41.6433 14.5471C41.6433 13.2304 42.156 11.9925 43.0871 11.0613L44.2266 9.9218L37.4243 3.11963L3 37.5439L9.80217 44.3461L10.9417 43.2066C11.8727 42.2755 13.1107 41.7628 14.4274 41.7628C15.7442 41.7628 16.9819 42.2755 17.9131 43.2066C18.8441 44.1376 19.3568 45.3755 19.3568 46.6922C19.3568 48.0089 18.8441 49.2468 17.9131 50.1779L16.7735 51.3175L23.5757 58.1196L58 23.6953L51.1978 16.8932ZM21.2198 51.2055C22.1047 49.8796 22.58 48.3224 22.58 46.6922C22.58 44.5145 21.732 42.4673 20.1921 40.9275C18.6523 39.3876 16.605 38.5396 14.4274 38.5396C12.7972 38.5396 11.24 39.015 9.9141 39.8998L7.55813 37.5439L37.4243 7.67775L39.7802 10.0337C38.8953 11.3596 38.42 12.9168 38.42 14.5471C38.42 16.7247 39.268 18.772 40.8079 20.3117C42.3477 21.8516 44.395 22.6996 46.5726 22.6996C48.2028 22.6996 49.76 22.2243 51.0859 21.3395L53.4419 23.6953L23.5757 53.5615L21.2198 51.2055Z",
    fill: "#01B9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.115 23.7175L32.8359 25.9966L35.1241 28.2847L37.4031 26.0057L35.115 23.7175Z",
    fill: "#01B9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5369 19.1394L28.2578 21.4185L30.546 23.7066L32.825 21.4276L30.5369 19.1394Z",
    fill: "#01B9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6931 28.2937L37.4141 30.5728L39.7022 32.8609L41.9813 30.5819L39.6931 28.2937Z",
    fill: "#01B9FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.50cdf5894ddb5ce578342a3cea1d07fc.svg";
export { ForwardRef as ReactComponent };